import NpcPayRouter from './npcpay-router';

export default NpcPayRouter;
